import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/app/auth-context';
import { Button, EmptyState } from '@/components/ui/primitives';

export function NoTenantState() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isOwner = user?.role === 'owner';
  const isTester = user?.isTester === true;

  if (isTester) {
    return (
      <EmptyState
        title="Cadastrar conta"
        description="Como tester, você pode cadastrar suas próprias contas em Configurações para começar o pipeline."
        action={
          <Button variant="primary" size="sm" onClick={() => navigate('/settings')}>
            Ir para Configurações
          </Button>
        }
      />
    );
  }

  return (
    <EmptyState
      title={isOwner ? 'Cadastrar conta' : 'Nenhuma conta vinculada'}
      description={
        isOwner
          ? 'Nenhuma conta cadastrada ainda. Cadastre em Admin para começar o pipeline de enriquecimento.'
          : 'Nenhuma conta VTEX foi vinculada ao seu usuário. Peça ao owner para liberar o acesso.'
      }
      action={
        isOwner ? (
          <Button variant="primary" size="sm" onClick={() => navigate('/admin?tab=accounts')}>
            Ir para Admin
          </Button>
        ) : undefined
      }
    />
  );
}
